import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

function initials(name) {
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials"
      className="py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-gray-500">
            Client Experiences
          </span>
          <h2 className="mt-2 text-3xl sm:text-4xl font-bold font-heading tracking-tight text-[#0F2D52]">
            What our clients say
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              data-testid={`testimonial-${i}`}
              className="rounded-2xl bg-white border border-gray-200 p-6 hover:shadow-[0_12px_32px_rgba(15,45,82,0.08)] mm-transition"
            >
              <Quote className="h-6 w-6 text-[#D4AF37]" strokeWidth={1.6} />
              <p className="mt-3 text-sm text-gray-700 leading-relaxed">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-1 mt-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} className="h-4 w-4 fill-[#D4AF37] text-[#D4AF37]" />
                ))}
                {Array.from({ length: 5 - t.rating }).map((_, j) => (
                  <Star key={`e${j}`} className="h-4 w-4 text-gray-300" />
                ))}
              </div>
              <div className="mt-4 pt-4 border-t border-gray-100 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#0F2D52] text-white flex items-center justify-center text-xs font-bold">
                  {initials(t.name)}
                </div>
                <div>
                  <div className="text-sm font-semibold text-[#0F2D52]">{t.name}</div>
                  <div className="text-xs text-gray-500">{t.city}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
